import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'noprblm | strategic, creative & tech partners',
  description = 'strategic, creative & tech partners to the world\'s best brands and creators. expert services in digital design, creative direction & virtual experience.',
  keywords = 'noprblm, creative agency, tech partners, brand strategy, digital design, creative direction, virtual experience',
  canonicalUrl = 'https://www.noprblm.com',
  ogImage = '/og-image.jpg',
  ogType = 'website'
}) => {
  const siteUrl = 'https://www.noprblm.com';
  const fullCanonicalUrl = `${siteUrl}${canonicalUrl === '/' ? '' : canonicalUrl}`;
  const fullOgImageUrl = `${siteUrl}${ogImage}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImageUrl} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullOgImageUrl} />
    </Helmet>
  );
};

export default SEO;